import React from 'react';
import PropTypes from 'prop-types';

import Modal, {
  ModalContent,
} from 'views/Modal';

const MojoPopup = ({
  show,
  showCloseModalIcon,
  contentContainerStyle,
  children,
  onShow,
  onClose,
}) => (
  <Modal
    show={show}
    backdropStyle={{
      background: 'rgba(0, 0, 0, 0.75)',
    }}
    onShow={onShow}>
    <ModalContent
      style={{ position: 'relative', ...contentContainerStyle }}
      modalClose={{
        style: {
          color: '#E83C58',
          right: '4px',
          top: '16px',
        },
        onRequestClose: () => onClose(),
      }}
      isClosable={showCloseModalIcon}
    >
      <div className="background-white" style={{ borderRadius: '4px', padding: '16px 0px' }}>
        {children}
      </div>
    </ModalContent>
  </Modal>
);

MojoPopup.propTypes = {
  show: PropTypes.bool,
  showCloseModalIcon: PropTypes.bool,
  contentContainerStyle: PropTypes.object,
  children: PropTypes.node,
  onShow: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

export default MojoPopup;



// WEBPACK FOOTER //
// ./src/common/views/MojoPopup.js